import React from "react";
import { useContext } from 'react';
import { Container, Row, Col, } from "react-bootstrap";
import { Link } from 'react-router-dom';

const Footer = ({translate}) => {

  return (
    <footer className="footer bg-light text-dark py-3">
      <Container>
        <Row>
          <Col md={6}>
            <p className="text-dark mx-2">© {new Date().getFullYear()} Casa Benicassim. {translate('footer.rights')}</p>
          </Col>
          <Col md={6} className="text-md-end">
<p className="text-dark mx-2"> Nº de Inscripción: CV-VUT0046385-CS | <Link to="/terms">{translate('footer.terms')} </Link> </p>
          
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
